'use client';

import ColumnComponent from '@molecules/ColumnComponent/ColumnComponent';
import { StyledMultiColumnContainerComponent } from './MultiColumnContainerComponent.styles';
import type { ComponentWsDTO, ContentSlotWsDTO } from '@occ/api-client';

interface Props {
  data: ComponentWsDTO;
  context?: SlotContextType;
}

interface CmsComponentContentSlotWsDTO extends ContentSlotWsDTO {
  cmsComponents: string;
  cmsComponentTypeCodes: string;
  uuid: string;
  widthPercent: string;
}
export interface ColumnContainerContentSlotWsDTO extends ComponentWsDTO {
  columnContainerData: Array<CmsComponentContentSlotWsDTO> | CmsComponentContentSlotWsDTO;
  hideInWeb: 'true' | 'false';
}

const MultiColumnContainerComponent = ({ data, context }: Props) => {
  const contentSlot = data as ColumnContainerContentSlotWsDTO;
  const showContainer = contentSlot.hideInWeb === 'false';

  const contentSlotArray =
    !!contentSlot.columnContainerData && !Array.isArray(contentSlot.columnContainerData)
      ? [contentSlot.columnContainerData]
      : contentSlot.columnContainerData;

  const slotArrayHasContent = contentSlotArray?.some((slot) => slot.cmsComponents);

  return (
    <>
      {showContainer && contentSlotArray?.length > 0 && slotArrayHasContent && (
        <StyledMultiColumnContainerComponent>
          {contentSlotArray.map(
            (child) => child.cmsComponents && <ColumnComponent key={child.uuid} column={child} context={context} />
          )}
        </StyledMultiColumnContainerComponent>
      )}
    </>
  );
};

export default MultiColumnContainerComponent;
